import { useState } from 'react'

// custom hook used to force a component to update by updating an arbitrary React state
export function useForceUpdate() {
  const [value, setValue] = useState(0)
  return () => setValue(value + 1)
}
